import React, { useMemo, useState, useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { useStore } from '../../hooks';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import axios from 'axios';
import { extractAccessToken } from '../../helpers';

const SUPERSET_BASE = 'https://superset.sonarinno.com';
const SUPERSET_PASS = 'AG1q2w3e4r';
const SUPERSET_ADMIN = 'embedded';

// const DASHBOARD_ID = '634e479a-2107-47a6-bedf-398b0a0bab1a';

async function login() {
    const response = await fetch(`${SUPERSET_BASE}/api/v1/security/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            provider: 'db',
            username: SUPERSET_ADMIN,
            password: SUPERSET_PASS,
            refresh: true
        })
    });
    if (!response.ok) {
        console.error('Login failed', await response.json());
        throw new Error('Login failed');
    }

    const data = await response.json();
    return data;
}

async function createCSRFToken(accessToken) {
    const uri = `${SUPERSET_BASE}/api/v1/security/csrf_token/`;

    const response = await fetch(uri, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    if (!response.ok) {
        throw new Error('Failed to create CSRF token');
    }

    const data = await response.json();
    return {
        csrfToken: data.result,
        referer: uri
    };
}

async function createGuestToken(uuid: string) {
    const { access_token } = await login();
    // console.log({ access_token });
    const { csrfToken, referer } = await createCSRFToken(access_token);

    const response = await fetch(`${SUPERSET_BASE}/api/v1/security/guest_token/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access_token}`,
            'X-CSRFToken': csrfToken,
            Referer: referer
        },
        body: JSON.stringify({
            resources: [
                {
                    type: 'dashboard',
                    id: uuid
                }
            ],
            rls: [],
            user: {
                username: 'embedded',
                first_name: 'embedded',
                last_name: 'embedded'
            }
        })
    });
    if (!response.ok) {
        throw new Error('Failed to create guest token');
    }

    const data = await response.json();
    return data.token;
}

async function getUserDashboardConfig(token: string, citizen_id: string) {}

type DashboardItem = {
    dashboard_id: string;
    dashboard_title: string;
    url: string;
    thumbnail_url: string;
    dashboard_group_name: string;
};

type DashboardItemInfo = {
    dashboard_id: string;
    uuid: string;
};

type DynamicTab = {
    id: string;
    label: string;
    icon: string;
    content: React.ReactNode;
    dashboardId?: string;
    uuid?: string;
};

type DashboardConfig = {
    dashboard_config_id: string;
    user_id: string;
    dashboard_title: string;
    dashboard_uuid: string;
};

function DashboardTabs() {
    const { subDashboardStore } = useStore();
    const [activeTab, setActiveTab] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [dashboards, setDashboards] = useState<DashboardItem[]>([]);
    const [dynamicTabs, setDynamicTabs] = useState<DynamicTab[]>([]); // เก็บแท็บที่เพิ่มแบบไดนามิก
    const [isSaving, setIsSaving] = useState(false);
    const dashboardContainerRef = useRef<HTMLDivElement | null>(null);
    const dashboardRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
    const selectDashBoard = subDashboardStore.selectedApplication;

    const dashboardTable = (
        <table className="min-w-full divide-y divide-gray-200 overflow-hidden rounded-lg shadow-lg">
            <thead className="bg-[#E55C00] text-white">
                <tr>
                    <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-semibold uppercase tracking-wider"
                    >
                        ID
                    </th>
                    <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-semibold uppercase tracking-wider"
                    >
                        Dashboard Name
                    </th>
                    <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-semibold uppercase tracking-wider"
                    >
                        Group
                    </th>
                    {/*<th*/}
                    {/*    scope="col"*/}
                    {/*    className="px-6 py-3 text-center text-xs font-semibold uppercase tracking-wider"*/}
                    {/*>*/}
                    {/*    Thumbnail*/}
                    {/*</th>*/}
                    <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-semibold uppercase tracking-wider"
                    >
                        Action
                    </th>
                </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
                {dashboards.map((item, index) => (
                    <tr
                        key={item.dashboard_id}
                        className="transition duration-150 ease-in-out hover:bg-gray-50"
                    >
                        <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                            {index + 1}
                        </td>
                        <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-700">
                            {item.dashboard_title}
                        </td>
                        <td className="whitespace-nowrap px-6 py-4 text-center text-sm text-gray-700">
                            {item.dashboard_group_name}
                        </td>
                        {/*<td className="whitespace-nowrap px-6 py-4 text-center">*/}
                        {/*    <img*/}
                        {/*        src={*/}
                        {/*            item.thumbnail_url*/}
                        {/*                ? // ? `${SUPERSET_BASE}${item.thumbnail_url}`*/}
                        {/*                  `https://upload.wikimedia.org/wikipedia/commons/3/33/Meta-chart.jpeg`*/}
                        {/*                : `https://picsum.photos/160/90`*/}
                        {/*        }*/}
                        {/*        alt={item.thumbnail_url ? 'รูปตัวอย่าง' : 'ไม่มีรูปตัวอย่าง'}*/}
                        {/*        className="h-16 w-auto rounded-md object-cover shadow-md"*/}
                        {/*    />*/}
                        {/*</td>*/}
                        <td className="whitespace-nowrap px-6 py-4 text-center text-sm font-medium">
                            <button
                                onClick={() => handleAddToDashboard(item)}
                                className="inline-flex items-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition duration-150 ease-in-out hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="mr-2 h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                                Add to dashboard
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );

    // ฟังก์ชันสร้างแท็บ dashboard ใหม่
    const createDashboardTab = (dashboardItem: DashboardItem, uuid: string): DynamicTab => {
        const tabId = `dashboard-${dashboardItem.dashboard_id}`;

        return {
            id: tabId,
            label: dashboardItem.dashboard_title,
            icon: '📊',
            dashboardId: dashboardItem.dashboard_id,
            uuid: uuid,
            content: (
                <div className="space-y-6">
                    <div className="rounded-lg border bg-white p-6 shadow-sm">
                        <div className="mb-4 flex items-center justify-between">
                            <h3 className="text-lg font-semibold text-gray-900">
                                {dashboardItem.dashboard_title}
                            </h3>
                            <button
                                onClick={() => handleRemoveTab(tabId)}
                                className="rounded bg-red-500 px-3 py-1 text-sm font-semibold text-white hover:bg-red-600"
                            >
                                ✕ ปิด
                            </button>
                        </div>
                        {loading && (
                            <div className="flex items-center justify-center py-8">
                                <div className="text-blue-600">กำลังโหลด dashboard...</div>
                            </div>
                        )}
                        {error && (
                            <div className="rounded-lg bg-red-50 p-4">
                                <div className="text-red-600">เกิดข้อผิดพลาด: {error}</div>
                                <button
                                    onClick={() => loadDashboard(uuid, tabId)}
                                    className="mt-2 rounded bg-red-600 px-4 py-2 text-white hover:bg-red-700"
                                >
                                    ลองใหม่
                                </button>
                            </div>
                        )}
                        <div
                            ref={el => (dashboardRefs.current[tabId] = el)}
                            className="min-h-[600px] rounded-lg border bg-gray-50"
                        />
                    </div>
                </div>
            )
        };
    };

    // รวมแท็บ static และ dynamic
    const allTabs = useMemo(() => {
        const staticTabs: DynamicTab[] = [
            {
                id: 'add_dashboard',
                label: 'Add Dashboard',
                icon: '➕',
                content: dashboardTable
            }
        ];

        return [...staticTabs, ...dynamicTabs];
    }, [loading, error, dashboards, dynamicTabs]);

    async function handleAddToDashboard(item: DashboardItem) {
        try {
            // ตรวจสอบว่าแท็บนี้มีอยู่แล้วหรือไม่
            const existingTab = dynamicTabs.find(tab => tab.dashboardId == item.dashboard_id);
            if (existingTab) {
                // หากมีแล้วให้เปลี่ยนไปที่แท็บนั้น
                const tabIndex = allTabs.findIndex(tab => tab.id == existingTab.id);
                setActiveTab(tabIndex);
                return;
            }

            const dashboardInfo = await fetchDashboardInfo(item.dashboard_id);

            if (dashboardInfo && dashboardInfo.uuid) {
                // สร้างแท็บใหม่
                const newTab = createDashboardTab(item, dashboardInfo.uuid);

                // เพิ่มแท็บใหม่เข้าไปใน state
                setDynamicTabs(prev => [...prev, newTab]);
                // console.log('DynamicTabs =>', dynamicTabs);

                // เปลี่ยนไปที่แท็บใหม่
                setTimeout(() => {
                    const newTabIndex = allTabs.length; // เพราะจะเป็นแท็บสุดท้าย
                    setActiveTab(newTabIndex);

                    // โหลด dashboard ใหม่
                    loadDashboard(dashboardInfo.uuid, newTab.id);
                }, 100);
            }
        } catch (error) {
            console.error('Error adding dashboard:', error);
            alert('ไม่สามารถเพิ่ม Dashboard นี้ได้ในขณะนี้');
        }
    }

    const handleSaveDashboard = () => {
        setIsSaving(true);

        const saveData = dynamicTabs.map((tab, index) => ({
            tab_id: index + 1,
            dashboard_id: tab.dashboardId
        }));

        axios
            .post('/v1/dashboard/user_config', saveData, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('SSO_AUTH')}`
                }
            })
            .then(() => {
                alert('บันทึก Dashboard สำเร็จ');
            })
            .catch(error => {
                console.error('เกิดข้อผิดพลาดในการบันทึก:', error);
                alert('เกิดข้อผิดพลาดในการบันทึก Dashboard');
            })
            .finally(() => {
                setIsSaving(false);
            });
    };

    // ฟังก์ชันลบแท็บ
    const handleRemoveTab = (tabId: string) => {
        setDynamicTabs(prev => prev.filter(tab => tab.id !== tabId));

        // หากแท็บที่ลบเป็นแท็บที่กำลังแสดงอยู่ ให้เปลี่ยนไปแท็บแรก
        const removedTabIndex = allTabs.findIndex(tab => tab.id === tabId);
        if (activeTab === removedTabIndex) {
            setActiveTab(0);
        } else if (activeTab > removedTabIndex) {
            setActiveTab(activeTab - 1);
        }
    };

    const fetchDashboardInfo = async (dashboardId: string): Promise<{ uuid: string } | null> => {
        try {
            // console.log('dashboardId ก่อนส่ง', dashboardId);
            const { access_token } = await login();

            const response = await fetch(
                `${SUPERSET_BASE}/api/v1/dashboard/${dashboardId}/embedded`,
                {
                    headers: {
                        Authorization: `Bearer ${access_token}`
                    }
                }
            );
            if (!response.ok) {
                throw await response.json();
            }
            const data = await response.json();

            // console.log('dashboard info', data.result);
            return data.result;
        } catch (e) {
            alert('ยังไม่สามารถเพิ่ม Dashboard นี้ได้ในขณะนี้ ขออภัยในความไม่สะดวก');
            console.error('fetchDashboardInfo() error msg => ', e);
            return null;
        }
    };

    const loadDashboard = async (uuid: string, containerId?: string) => {
        try {
            setLoading(true);
            setError(null);

            const guestToken = await createGuestToken(uuid);
            // console.log('Guest Token:', guestToken);

            // เลือก container ที่เหมาะสม
            const container =
                containerId && dashboardRefs.current[containerId]
                    ? dashboardRefs.current[containerId]
                    : dashboardContainerRef.current;

            if (container) {
                const metaId = 'EDEZ0JlDSV8JIoOTLe3Ow';
                const column = 'web_id';
                const selectDashBoardArr = selectDashBoard.split(' ');

                if (selectDashBoardArr.length < 2) {
                    return;
                }

                let webId = selectDashBoardArr[1].trim().toUpperCase();

                const webIdMap = {
                    SCGCEMENT: 'SCG',
                    TEXPLORE: 'TEX'
                };

                webId = webIdMap[webId] || webId;
                const value = webId;

                // console.log('uuid=>', uuid);

                embedDashboard({
                    id: uuid,
                    supersetDomain: SUPERSET_BASE,
                    mountPoint: container,
                    fetchGuestToken: () => guestToken,
                    dashboardUiConfig: {
                        hideTitle: true,
                        hideTab: true,
                        hideChartControls: true,
                        urlParams: {
                            native_filters: `(NATIVE_FILTER-${metaId}:(__cache:(label:'${value}',validateStatus:!f,value:!('${value}')),extraFormData:(filters:!((col:${column},op:IN,val:!('${value}')))),filterState:(label:'${value}',validateStatus:!f,value:!('${value}')),id:NATIVE_FILTER-${metaId},ownState:()))`
                        },
                        filters: {
                            expanded: false,
                            visible: false
                        }
                    }
                });

                setInterval(async () => {
                    const iframes = document.querySelectorAll('iframe');
                    iframes.forEach(iframe => {
                        if (iframe && iframe.parentElement === container) {
                            iframe.style.width = '100%';
                            iframe.style.height = '600px';
                            iframe.style.border = 'none';
                            iframe.style.borderRadius = '8px';
                        }
                    });
                }, 1000);
            }
        } catch (err) {
            console.error('Error loading dashboard:', err);
            // @ts-ignore
            setError(err.message || 'เกิดข้อผิดพลาดในการโหลด dashboard');
        } finally {
            setLoading(false);
        }
    };

    const fetchDashboards = async () => {
        try {
            // const { access_token } = await login();
            const response = await fetch(`/v1/dashboard`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('SSO_AUTH')}`
                }
            });
            if (!response.ok) {
                throw await response.json();
            }
            const data = await response.json();

            // console.log('dashboard list', data.result_list);
            setDashboards(data.result_list);
        } catch (e) {
            console.error('fetchDashboards() error msg => ', e);
        }
    };

    const renderUserDashboardConfig = async () => {
        const dashboardConfig = await getUserDashboardConfig();
        // console.log('dashboard config', dashboardConfig);

        if (dashboardConfig.total_count > 0) {
            dashboardConfig.result_list.forEach(dashboard => {
                const dashboardItem: DashboardItem = {
                    dashboard_id: dashboard.dashboard_id,
                    dashboard_title: dashboard.dashboard_title,
                    url: '',
                    thumbnail_url: '',
                    dashboard_group_name: ''
                };
                const newTab = handleAddToDashboard(dashboardItem);
            });
        }
    };

    const getUserDashboardConfig = async () => {
        const dashboardConfig = await axios.get('/v1/dashboard/user_config', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('SSO_AUTH')}`
            },
            params: {
                citizenId: extractAccessToken().citizen_id
            }
        });

        return dashboardConfig.data;
    };

    // ทำงานครั้งเดียวตอน component mount
    useEffect(() => {
        renderUserDashboardConfig();
    }, []);

    useEffect(() => {
        if (activeTab === 0) {
            fetchDashboards();
        }

        const existingTab = dynamicTabs[activeTab - 1];
        if (existingTab && existingTab.uuid && existingTab.label && activeTab !== 0) {
            loadDashboard(existingTab.uuid, existingTab.id);
        }
    }, [activeTab, dynamicTabs, selectDashBoard]);

    return (
        <div className="min-h-screen w-full bg-gray-50">
            <div className="px-4 py-8 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="mb-8">
                    <div className="flex items-center justify-between">
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
                            <p className="mt-1 text-gray-600">
                                ภาพรวมและสถิติของธุรกิจจาก focusOne ERP
                            </p>
                        </div>
                        <button
                            onClick={handleSaveDashboard}
                            type="button"
                            disabled={isSaving}
                            className={`inline-flex items-center rounded-lg px-4 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2
                            ${
                                isSaving
                                    ? 'cursor-not-allowed bg-gray-400'
                                    : 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500'
                            }`}
                        >
                            {isSaving ? 'กำลังบันทึก...' : 'บันทึก'}
                        </button>
                    </div>
                </div>

                {/* Tabs Navigation */}
                <div className="mb-8">
                    <div className="border-b border-gray-200">
                        <nav className="-mb-px flex space-x-8 overflow-x-auto">
                            {allTabs.map((tab, index) => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(index)}
                                    className={twMerge(
                                        'group inline-flex items-center whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium transition-colors duration-200',
                                        activeTab === index
                                            ? 'border-blue-500 text-blue-600'
                                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                                    )}
                                >
                                    <span className="mr-2 text-lg">{tab.icon}</span>
                                    {tab.label}
                                </button>
                            ))}
                        </nav>
                    </div>
                </div>

                {/* Tab Content */}
                <div className="tab-content">{allTabs[activeTab]?.content}</div>
            </div>
        </div>
    );
}

export default observer(DashboardTabs);
